// Component for rendering hiplot (in new page)
import React from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import * as hip from 'hiplot';

const HiPlot = () => {
	const [hiPlot, setHiPlot] = React.useState();

	let { data, index } = useParams();
	const string = data.replace(/,/g, '+');
	React.useEffect(() => {
		fetchHiPlotData();
	}, []);
	const fetchHiPlotData = async () => {
		try {
			if (data && index) {
				const hiplotData = await axios.get(
					`/cluster/${index}/features_dict/${string}`
				);
				const experiment = hip.Experiment.from_iterable(hiplotData.data);
				experiment.display_data[hip.DefaultPlugins.TABLE] = {
					hide: ['uid', 'from_uid']
				};
				setHiPlot(experiment);
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div style={{ backgroundColor: 'rgb(247,247,247)' }}>
			<div style={{ padding: '0 100px' }}>
				{hiPlot && <hip.HiPlot experiment={hiPlot} isWebServer={false} />}
			</div>
		</div>
	);
};

export default HiPlot;
